import {LoadingButton} from "@mui/lab";
import CircularProgress from "@mui/material/CircularProgress";
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import type {ComponentProps, MouseEvent} from "react";
import {useServerTableToolbarItemContext} from "../ServerTableToolbarContext";
import {defineServerTableToolbarItem} from "../ServerTableToolbarItem";
import type {ServerTableToolbarAlign} from "../ServerTableToolbarItem";
import {serverTableTextControlSx} from "../constants";

type ServerTableToolbarActionProps = Omit<ComponentProps<typeof LoadingButton>, 'id' | 'size' | 'sx'> & {
    /** Page-owned scope pickers belong left; everything else joins the managed group. */
    align?: ServerTableToolbarAlign
};

const ServerTableToolbarActionComponent = ({
    variant = 'outlined',
    children,
    startIcon,
    loading,
    disabled,
    onClick,
    align: _align,
    ...props
}: ServerTableToolbarActionProps) => {
    const toolbarItem = useServerTableToolbarItemContext();

    if (toolbarItem.presentation === 'menu') {
        return (
            <MenuItem
                disabled={disabled || loading}
                onClick={event => {
                    toolbarItem.closeMenu();
                    onClick?.(event as unknown as MouseEvent<HTMLButtonElement>);
                }}
            >
                {(loading || startIcon) && (
                    <ListItemIcon sx={{color: 'primary.main'}}>
                        {loading ? <CircularProgress color="inherit" size={18}/> : startIcon}
                    </ListItemIcon>
                )}
                {children}
            </MenuItem>
        );
    }

    return (
        <LoadingButton
            {...props}
            size="small"
            variant={variant}
            color="primary"
            startIcon={startIcon}
            loading={loading}
            disabled={disabled}
            onClick={onClick}
            sx={serverTableTextControlSx}
        >
            {children}
        </LoadingButton>
    );
};

export const ServerTableToolbarAction = defineServerTableToolbarItem(
    ServerTableToolbarActionComponent
);
